import { FC, useCallback, useRef } from 'react';
import { HorizontalScroller } from '@edikk-edikk/horizontal-scroller';
import { StoryType } from '@edikk-edikk/country-frontend';
import storyListWrapperCss from '../assets/story-list-wrapper.module.scss';
import storyListCss from '../assets/story-list.module.scss';
import { StoryDetailListWrapper, StoryDetailListWrapperType } from '#advertStory/detail-list-wrapper';
import { StoryItem } from '#advertStory/item';
import { StoryListContext, StoryListContextType } from '#advertStory/list';

type PropsType = {
  storyDataList: StoryType[];
};

const StoryList: FC<PropsType> = ({
  storyDataList,
}) => {
  const refStoryDetailListWrapper = useRef<StoryDetailListWrapperType>(null);

  const openDetail = useCallback((id: number): void => {
    refStoryDetailListWrapper.current.open(id);
  }, []);

  if (storyDataList.length === 0) {
    return null;
  }

  const storyItemList = storyDataList.map((story, index) => (
    <StoryItem key={story.id} story={story} storyIndex={index} />
  ));

  const storyListContextValue: StoryListContextType = {
    openDetail,
    storyDataList,
  };

  return (
    <StoryListContext value={storyListContextValue}>
      <HorizontalScroller
        additionalClassName={storyListWrapperCss.storyListWrapper}
        innerAdditionalClassName={storyListCss.storyList}
      >
        {storyItemList}
      </HorizontalScroller>
      <StoryDetailListWrapper ref={refStoryDetailListWrapper} />
    </StoryListContext>
  );
};

export { StoryList };
